module.exports = __webpack_public_path__ + "static/img/egud.d73d3c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/egud.jpg
// module id = ZIKI
// module chunks = 6